import { createApp } from 'vue'
import App from './App.vue'
// main.js
import 'vant/lib/index.css';
import router from './route/index'; // 引入刚刚创建的路由

createApp(App).use(router).mount('#app'); // 使用路由
